declare global {
  interface Window {
    lintrk?: ((action: string, data?: Record<string, unknown>) => void) & {
      q?: unknown[][];
    };
  }
}

export const LINKEDIN_CHECKOUT_CONVERSION_ID = 28484522;

export function trackLinkedInCheckoutConversion(email: string) {
  if (typeof window === 'undefined' || typeof window.lintrk !== 'function') {
    return;
  }

  const trimmedEmail = email.trim();
  if (trimmedEmail) {
    window.lintrk('setUserData', { email: trimmedEmail });
  }

  window.lintrk('track', {
    conversion_id: LINKEDIN_CHECKOUT_CONVERSION_ID,
  });
}
